import { PageHeader, PageBody } from "@/components/AppShell";
import { RebookingsPanel } from "@/pages/Admin";

// Page DÉDIÉE (accès direct depuis le menu) pour le SUIVI des primes de rebooking terrain.
// Comme il s'agit d'argent (50 €/spot), l'admin doit la trouver facilement — d'où une
// entrée de navigation propre plutôt qu'un onglet enfoui dans l'Administration.
export default function PrimesRebooking() {
  return (
    <div data-testid="primes-rebooking-page">
      <PageHeader
        title="Primes rebooking"
        subtitle="Suivi des spots rebookés sur le terrain par les recruteurs — 50 € par emplacement (compté une seule fois, quel que soit le nombre de dates). Chaque ligne indique le magasin, les dates et la prime."
      />
      <PageBody>
        <RebookingsPanel />
      </PageBody>
    </div>
  );
}
